export class FinanceResponseError extends Error {
    constructor() {
        super('Сервер вернул некорректные данные финансов. Обновите страницу или повторите загрузку.');
    }
}

export function requireFinancePage(value: unknown): void {
    const page = value as { items?: unknown; pages?: unknown } | null;
    if (!page || !Array.isArray(page.items)
        || !page.items.every(item => item !== null && typeof item === 'object' && !Array.isArray(item))
        || typeof page.pages !== 'number' || !Number.isInteger(page.pages) || page.pages < 0) {
        throw new FinanceResponseError();
    }
}

export function requireFinanceAccount(value: unknown): void {
    if (!value || typeof value !== 'object' || Array.isArray(value)
        || typeof (value as { id?: unknown }).id !== 'string') {
        throw new FinanceResponseError();
    }
}
